export const SEND_SUBSCRIPTION_SUCCESS = 'SEND_SUBSCRIPTION_SUCCESS';
export const SEND_SUBSCRIPTION_FAILURE = 'SEND_SUBSCRIPTION_FAILURE';
export const LOGIN_WEBSOCKET = 'LOGIN_WEBSOCKET';
export const WEBSOCKET_CONNECTION = 'WEBSOCKET_CONNECTION';
export const WEBSOCKET_DISCONNECTION = 'WEBSOCKET_DISCONNECTION';
export const LOGOUT_WEBSOCKET = 'LOGOUT_WEBSOCKET';
